import { SolucionPage } from "@/components/SolucionPage";
import { getSolucion } from "@/lib/soluciones";

export default function SeguimientoAutomatico() {
  const solucion = getSolucion("seguimiento-automatico")!;
  return <SolucionPage solucion={solucion} />;
}
